import React from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import '../../sass/components/flexibleModules/_components.logosGalleryComponent.scss';

const LogosGalleryComponent = ({ data }) => {
    return (
        <div className="cp-logosGalleryComponent" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-logosGalleryComponent__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                {data.logosGalleryHeader &&
                    <h2>{data.logosGalleryHeader}</h2>
                }
                {data.logosGalleryTeaser &&
                    <p>{data.logosGalleryTeaser}</p>
                }
                {data.logosGalleryImages &&
                    <div className="cp-logosGalleryComponent__image l--flex">
                        {data.overrideClass ?
                            <>
                                {data.overrideClass === 'l-badges' ?
                                    <div className="cp-logosGalleryComponent__image-wrap">
                                        <div className="cp-logosGalleryComponent__image-logo cp-logosGalleryComponent__image-top l--flex">
                                            {data.logosGalleryImages.map((image, index) => (
                                                <>
                                                    {index <= 3 &&
                                                        <div className="cp-logosGalleryComponent__image-section" key={index}>
                                                            {image.sourceUrl &&
                                                                <img loading="lazy" src={image.sourceUrl} alt={image.altText} />
                                                            }
                                                        </div>
                                                    }
                                                </>
                                            ))}
                                        </div>
                                        <div className="cp-logosGalleryComponent__image-logo cp-logosGalleryComponent__image-bottom l--flex">
                                            {data.logosGalleryImages.map((image, index) => (
                                                <>
                                                    {index > 3 &&
                                                        <div className="cp-logosGalleryComponent__image-section" key={index}>
                                                            {image.sourceUrl &&
                                                                <img loading="lazy" src={image.sourceUrl} alt={image.altText} />
                                                            }
                                                        </div>
                                                    }
                                                </>
                                            ))}
                                        </div>
                                    </div>
                                    :
                                    <>
                                        {data.logosGalleryImages.map((image, index) => (
                                            <div className="cp-logosGalleryComponent__image-section" key={index}>
                                                {image.sourceUrl &&
                                                    <img loading="lazy" src={image.sourceUrl} alt={image.altText} />
                                                }
                                            </div>
                                        ))}
                                    </>
                                }
                            </>
                            :
                            <>
                                {data.logosGalleryImages.map((image, index) => (
                                    <div className="cp-logosGalleryComponent__image-section" key={index}>
                                        {image.sourceUrl &&
                                            <img loading="lazy" src={image.sourceUrl} alt={image.altText} />
                                        }
                                    </div>
                                ))}
                            </>
                        }
                    </div>
                }
                {data.logosGalleryCta &&
                    <div className="l-relativeButton">
                        <a className="l-button" href={data.logosGalleryCta.url} target={data.logosGalleryCta.target}>
                            <span>{data.logosGalleryCta.title}</span>
                            <StaticImage src="../../images/arrow-right-white.svg" alt="" />
                        </a>
                        <a className="l-button l-backgroundHover" href={data.logosGalleryCta.url} target={data.logosGalleryCta.target}>
                            <span>{data.logosGalleryCta.title}</span>
                            <StaticImage src="../../images/arrow-right-white.svg" alt="" />
                        </a>
                    </div>
                }
            </div>
        </div>
    );
}

export default LogosGalleryComponent;